import { ApiError } from "@/lib/api";

/**
 * Mensaje para cuando falla el registro de la aceptación. Un 409 del backend
 * ya trae qué pasó y qué hacer (versión nueva, cuenta incompleta); cualquier
 * otro error se explica aquí, sin el texto crudo de la red.
 */
export function legalConsentErrorMessage(err: unknown): string {
  if (err instanceof ApiError && err.status === 409 && err.message) return err.message;
  return "No pudimos guardar tu aceptación. Revisa tu conexión e inténtalo de nuevo; tus casillas siguen marcadas.";
}
